import { VoicePreference } from '../../services/cxone-sdk.service';
import { CxoneConnectionStep } from '../../types';

export const CXONE_CONNECTION_STEPS = {
  endingSession: 'ending_session',
  initializingSdk: 'initializing_sdk',
  startingSession: 'starting_session',
  connectingVoice: 'connecting_voice',
} as const satisfies Record<string, CxoneConnectionStep>;

export function getCxoneConnectionSteps(
  preference: VoicePreference,
  options?: { includeEndingSession?: boolean }
): CxoneConnectionStep[] {
  const steps: CxoneConnectionStep[] = [];

  if (options?.includeEndingSession) {
    steps.push(CXONE_CONNECTION_STEPS.endingSession);
  }

  steps.push(CXONE_CONNECTION_STEPS.initializingSdk, CXONE_CONNECTION_STEPS.startingSession);

  if (preference.type === 'softphone') {
    steps.push(CXONE_CONNECTION_STEPS.connectingVoice);
  }

  return steps;
}

export function getStepStatus(
  step: CxoneConnectionStep,
  steps: CxoneConnectionStep[],
  activeStep: CxoneConnectionStep | null
): 'done' | 'active' | 'pending' {
  if (!activeStep) {
    return 'pending';
  }

  const stepIndex = steps.indexOf(step);
  const activeIndex = steps.indexOf(activeStep);

  if (stepIndex < 0 || activeIndex < 0) {
    return 'pending';
  }

  if (stepIndex < activeIndex) {
    return 'done';
  }

  if (stepIndex === activeIndex) {
    return 'active';
  }

  return 'pending';
}
